import BacklogPage from './pages/BacklogPage.vue'
// import BacklogTarefaPage from './pages/BacklogTarefaPage.vue'
// import BacklogPainelPage from './pages/BacklogPainelPage.vue';

const routes = [
  {
    path: 'backlog',
    name: 'backlog',
    component: BacklogPage,
  },
  // {
  //   path: 'backlog-tarefas',
  //   name: 'backlog-tarefas',
  //   component: BacklogTarefaPage,
  // },
  // {
  //   path: 'painel-alarmes',
  //   name: 'painel-alarmes',
  //   component: BacklogPainelPage,
  // }
];

export default routes;